import React from "react"
import { IconLock, IconTouch, IconHeart } from "../images"
import { useIntl } from "../hooks"

export default function ContentProsSecurity() {
  const { t } = useIntl()
  const contentProsSecurityFrames = [
    {
      id: 1,
      icon: <IconLock className="w-3.5 h-3.5 text-teal" />,
      heading: t("ContentPros__SecurityPrivacyOne--Heading"),
      desc: t("ContentPros__SecurityPrivacyOne--Desc"),
    },
    {
      id: 2,
      icon: <IconTouch className="w-3.5 h-3.5 text-socialieBlue" />,
      heading: t("ContentPros__SecurityPrivacyTwo--Heading"),
      desc: t("ContentPros__SecurityPrivacyTwo--Desc"),
    },
    {
      id: 3,
      icon: <IconHeart className="w-3.5 h-3.5 text-socialiePink" />,
      heading: t("ContentPros__SecurityPrivacyThree--Heading"),
      desc: t("ContentPros__SecurityPrivacyThree--Desc"),
    },
  ]
  return (
    <div className="flex flex-col items-center">
      <div className="w-full mb-2.5 text-left tablet:text-center laptop:text-center">
        <h5 className="text-h5 text-darkGrey tracking-12 leading-h5 font-black">
          {t("ContentPros__SecurityPrivacy--Subheading")}
        </h5>
      </div>
      <div className="w-full mb-5 text-left tablet:text-center laptop:text-center">
        <h3 className="text-h4 leading-h4 tracking-11 laptop:tracking-30 text-body font-serif">
          {t("ContentPros__SecurityPrivacy--Heading")}
        </h3>
      </div>
      <div className="w-full grid grid-cols-1 tablet:grid-cols-3 laptop:grid-cols-3 gap-5">
        {contentProsSecurityFrames.map((s) => (
          <div key={s.id} className="w-full px-4 py-5 bg-lightGrey rounded-32">
            <div className="mb-2.5">{s.icon}</div>
            <h4 className="mb-1.25 text-h5 text-body tracking-12 leading-h5 font-serif">{s.heading}</h4>
            <p className="text-body text-p tracking-10 leading-h6">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
